export enum FormFields {
  enabled = 'enabled',
  tier = 'tier',
  value = 'value',
}

export type FormValues = {
  [FormFields.enabled]: boolean
  [FormFields.tier]?: string
  [FormFields.value]?: number
}
